import RequestActionHelper from '@kakadu-dev/base-frontend-helpers/helpers/Redux/RequestActionHelper';
import { AUTHORIZATION_ACTIONS } from "./actionTypes";
export const AuthorizationActions = {
  userRole: RequestActionHelper.getActionCreatorFetch(AUTHORIZATION_ACTIONS.USER_ROLE),
  usersRoles: RequestActionHelper.getActionCreatorFetch(AUTHORIZATION_ACTIONS.USERS_ROLES),
  setUserRole: RequestActionHelper.getActionCreatorFetch(AUTHORIZATION_ACTIONS.SET_USER_ROLE)
};